






























































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import { AxiosResponse } from "axios";
import BaseMixin from "@/mixins/BaseMixin";
import Table from "@/components/Common/Table.vue";
import NavigationTabs from "@/components/Customers/Customer/NavigationTabs.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Error404 from "@/components/Common/Error404.vue";

import swal from "sweetalert";
import { IPagination, IParticipant, ITableParams } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox,
    NavigationTabs,
    Error404
  }
})
export default class CustomerParticipants extends Mixins(BaseMixin) {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private participants: Array<IParticipant> = [];
  private noDataExist = false;
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private selectedCustomerId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedCustomerId = vm.$route.params.customer_id;
      if (vm.$route.query.participant_deleted === "true") {
        swal("Success!", "The participant was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getCustomerParticipants(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.participant_deleted === "true") {
      swal("Success!", "The participant was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getCustomerParticipants(() => {
      //
    });
    next();
  }

  private getCustomerParticipants(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId + "/participants"
    );

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.participants = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteCustomerParticipant(participantId: number): void {
    if (
      this.loading ||
      this.updating ||
      this.selectedCustomerId == null ||
      participantId == null
    ) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The participant will be deleted.",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "participants/" + participantId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "CustomerParticipants",
                query: { participant_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The participant was deleted.", "success");
                  this.getCustomerParticipants(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete participants.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  @Watch("searchFilter")
  searchFilterChanged(): void {
    this.getCustomerParticipants(() => {
      //
    });
  }
}
